export default __webpack_public_path__ + "static/media/om-v2.210d0c8b.svg";